import { render } from "./SidebarLink.vue?vue&type=template&id=f038db06&scoped=true"
import script from "./SidebarLink.vue?vue&type=script&lang=ts"
export * from "./SidebarLink.vue?vue&type=script&lang=ts"

import "./SidebarLink.vue?vue&type=style&index=0&id=f038db06&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f038db06"

export default script